import React from "react";

import { THEME_SETTINGS } from "@theme-settings";

import CountryIcon from "./CountryIcon";
import JerseyIcon from "./JerseyIcon";

type TeamIconProps = {
	showCountryFlag?: boolean;
	className?: string;
	flagCode?: string;
	jerseyTypeAbrv?: string;
	opponentFlagCode?: string;
	opponentJerseyTypeAbrv?: string;
	hasPlaceholder?: boolean;
};

export default function TeamIcon(props: TeamIconProps) {
	if (!THEME_SETTINGS.features.isTeamIconEnabled) {
		return null;
	}

	const { showCountryFlag, className, flagCode, jerseyTypeAbrv, opponentFlagCode, opponentJerseyTypeAbrv, hasPlaceholder } = props;

	if (showCountryFlag == null) {
		return null;
	}

	if (showCountryFlag) {
		if (!flagCode && hasPlaceholder) {
			return (
				<div className="u-icon u-icon--country-placeholder u-mar--right--2" />
			);
		}
		return (
			<CountryIcon
				flagCode={flagCode}
				hasOpponent={!!opponentFlagCode}
				className={className}
			/>
		);
	}

	return (
		<JerseyIcon
			jerseyTypeAbrv={jerseyTypeAbrv}
			hasOpponent={!!opponentJerseyTypeAbrv}
			hasPlaceholder={hasPlaceholder}
			className={className}
		/>
	);
}
